import { render } from "./virtualNumberBinding.vue?vue&type=template&id=6c1ddb68&scoped=true"
import script from "./virtualNumberBinding.vue?vue&type=script&lang=js"
export * from "./virtualNumberBinding.vue?vue&type=script&lang=js"

import "./virtualNumberBinding.vue?vue&type=style&index=0&id=6c1ddb68&lang=scss&scoped=true"

import exportComponent from "D:\\lpl\\szy\\cloud-api-web-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c1ddb68"]])

export default __exports__